<template>
    <div class="page flex_box">

        <!-- 目录背景图 -->
        <div class="bg"></div>

        <!-- 目录 -->
        <div class="menu">

            <!-- top -->
            <div class="top">
                <div class="flex">
                    <div class="m_txt">Table of Contents </div>
                    <div><Vicon class="vicon" :icon="'menu-line'"/></div>
                </div>
            </div>

            <!-- 列表 -->
            <div class="m_list">
                <a-row class="mg_b" align="middle">
                    <a-col :span="2" class="ft">01</a-col>
                    <a-col class="l_txt">Background</a-col>
                </a-row>

                <a-row class="mg_b" align="middle">
                    <a-col :span="2" class="ft">02</a-col>
                    <a-col class="l_txt">Comprehensive Evaluation</a-col>
                </a-row>

                <div class="list mg_b">
                    <a-row class="mg_l" align="middle">
                        <a-col :span="2" class="ftl">03</a-col>
                        <a-col class="ll_txt">Operational Emissions</a-col>
                    </a-row>

                    <a-row class="mg_l" align="middle">
                        <a-col :span="2" class="ftl">04</a-col>
                        <a-col class="ll_txt">Industry Chain Emissions</a-col>
                    </a-row>

                    <a-row class="mg_l" align="middle">
                        <a-col :span="2" class="ftl">05</a-col>
                        <a-col class="ll_txt">Contribution to Direct Emission Reduction</a-col>
                    </a-row>

                    <a-row class="mg_l" align="middle">
                        <a-col :span="2" class="ftl">06</a-col>
                        <a-col class="ll_txt">Contribution to Indirect Emission Reduction</a-col>
                    </a-row>

                    <a-row class="mg_l" align="middle">
                        <a-col :span="2" class="ftl">07</a-col>
                        <a-col class="ll_txt">Zero-carbon Operation</a-col>
                    </a-row>

                    <a-row class="mg_l" align="middle">
                        <a-col :span="2" class="ftl">08</a-col>
                        <a-col class="ll_txt">Green Supply Chain</a-col>
                    </a-row>

                    <a-row class="mg_l" align="middle">
                        <a-col :span="2" class="ftl">09</a-col>
                        <a-col class="ll_txt">Pledges and Disclosure</a-col>
                    </a-row>

                    <a-row class="mg_l" align="middle">
                        <a-col :span="2" class="ftl">10</a-col>
                        <a-col class="ll_txt">Zero-carbon Investment</a-col>
                    </a-row>

                    <!-- <a-row class="mg_l" align="middle">
                        <a-col :span="2" class="ftl">11</a-col>
                        <a-col class="ll_txt">Other Emissions and Emission Reductions</a-col>
                    </a-row> -->
                </div>

                <a-row class="mg_b" align="middle">
                    <a-col :span="2" class="ft">11</a-col>
                    <a-col class="l_txt">Summary</a-col>
                </a-row>

                <a-row class="mg_b" align="middle">
                    <a-col :span="2" class="ft">12</a-col>
                    <a-col class="l_txt">Appendices</a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import Vicon from '@/layout/icon/index.vue'
import { useRoute, useRouter } from 'vue-router';
export default {
    name: 'page2',
    components:{Vicon},
    setup() {
        const data = reactive({})
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.flex_box{
    display: flex;
}
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    .bg{
        width: 540px;
        height: 100%;
        background: url('@/assets/img/menu_bg.png') no-repeat;
        background-size: cover;
    }
    .menu{
        width: 100%;
        .top{
            width: 100%;
            height: 318px;
            border-bottom: 2px solid #0DC7F5;
            padding: 180px 72px 40px 72px;
            .flex{
                display: flex;
                justify-content: space-between;
                .m_txt{
                    font-size: 50px;
                    font-weight: 500;
                    color: #013C89;
                    line-height: 100px;
                }
                .vicon{
                    font-size: 62px;
                    color: #83E4FB;
                }
            }
        }
        .m_list{
            padding: 82px 0 0 216px;
            .mg_b{
                margin-bottom: 54px;
            }
            .ft{
                font-size: 48px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #013C89;
                line-height: 67px;
            }
            .l_txt{
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #013C89;
                line-height: 50px;
            }
            .list{
                margin-left: 30px;
                padding-left: 45px;
                border-left: 2px solid #0DC7F5;
                .mg_l{
                    margin-bottom: 49px;
                    .ftl{
                        font-size: 26px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #013C89;
                        line-height: 37px;
                    }
                    .ll_txt{
                        font-size: 26px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #013C89;
                        line-height: 37px;
                    }
                }
            }
        }
    }
}
</style>